/**
 * State used in rendering BreadcrumbButton
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
